import gsap from 'gsap';

const selectors = {
  introPamplemousse: '.js-scroll-anim-intro-pamplemousse',
  navPamplemousse: '.js-header-pamplemousse',
  intro: '.js-scroll-anim-intro',
  introVideo: '.js-scroll-anim-intro-video',
  bgChange: '[data-bg-color]',
  ourStory: '.js-scroll-anim-our-story',
};

const classes = {
  visible: 'is-visible',
  active: 'is-active',
};

const init = () => {
  const isLandscape = window.innerWidth > window.innerHeight;

  const intro = document.querySelector(selectors.intro);
  const introPamplemousse = document.querySelector(selectors.introPamplemousse);
  const navPamplemousse = document.querySelector(selectors.navPamplemousse);
  const introVideo = document.querySelector(selectors.introVideo);
  const ourStory = document.querySelector(selectors.ourStory);

  if (intro && introPamplemousse) {
    gsap.to(introPamplemousse, {
      scrollTrigger: {
        trigger: intro,
        start: 'top top',
        end: `bottom top`,
        scrub: true,
        ease: 'none',
      },
      x: isLandscape
        ? (window.innerWidth - window.innerHeight / 2) / 2 +
          window.innerHeight / 2
        : '80%',
    });

    gsap.to(navPamplemousse, {
      scrollTrigger: {
        trigger: intro,
        start: 'bottom 25%',
        end: 'bottom 25%',
        onLeave: () => {
          navPamplemousse.classList.add(classes.visible);
        },
        onEnterBack: () => {
          navPamplemousse.classList.remove(classes.visible);
        },
      },
    });
  }

  const bgChanges = document.querySelectorAll(selectors.bgChange);

  bgChanges.forEach(section => {
    const bgColor = section.getAttribute('data-bg-color');

    gsap.to(document.body, {
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: 'bottom 25%',
        onEnter: () => {
          document.body.style.setProperty('--bg', bgColor);
          section.style.setProperty('--bg', bgColor);
        },
        onEnterBack: () => {
          document.body.style.setProperty('--bg', bgColor);
          section.style.setProperty('--bg', bgColor);
        },
        onLeave: () => {
          document.body.style.setProperty('--bg', '');
          section.style.setProperty('--bg', '');
        },
        onLeaveBack: () => {
          document.body.style.setProperty('--bg', '');
        },
      },
    });
  });

  if (introVideo) {
    gsap.to(introVideo, {
      scrollTrigger: {
        trigger: introVideo,
        start: 'top 25%',
        end: 'bottom 25%',
        toggleClass: { targets: introVideo, className: classes.active },
      },
    });
  }

  if (ourStory) {
    const paragraphs = ourStory.querySelectorAll('.g-our-story__title p');

    let typeTimeout = null;
    let prevIndex = 0;
    let mq = window.matchMedia('(min-width: 768px)');
    gsap.to(ourStory, {
      scrollTrigger: {
        trigger: ourStory,
        start: 'top top',
        end: `+=${window.innerHeight + (mq.matches ? 2000 : 500)}px bottom`,
        onUpdate: self => {
          const progress = self.progress;
          ourStory.style.setProperty('--progress', progress);
          const index = Math.floor(
            Math.max(
              0,
              Math.min(progress * paragraphs.length, paragraphs.length - 1),
            ),
          );

          paragraphs.forEach((p, i) => {
            if (i === prevIndex) return;
            if (i === index) {
              clearTimeout(typeTimeout);
              const charTotal = paragraphs[prevIndex].querySelectorAll('.char').length;
              typeTimeout = setTimeout(() => {
                p.classList.add(classes.active);
              }, charTotal * 30 + 100);
              prevIndex = i;
            } else {
              p.classList.remove(classes.active);
            }
          });
        },
        onLeave: () => {
          paragraphs.forEach(p => p.classList.remove(classes.active));
        }
      },
    });
  }
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
